"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TextArea = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextArea"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "edit-description": "EditDescription__edit-description__1tKMO",
  "editDescription": "EditDescription__edit-description__1tKMO",
  "description-footer": "EditDescription__description-footer__7jMG5",
  "descriptionFooter": "EditDescription__description-footer__7jMG5"
}; 
require('./EditDescription.css');
var MAX_LENGTH = 255;
var textAreaStyles = _TextArea.default.themes.DefaultTheme;
var Description = function Description(_ref) {
  var _editedDescription$le;
  var description = _ref.description,
    isDisabled = _ref.isDisabled,
    _ref$onEditDescriptio = _ref.onEditDescription,
    onEditDescription = _ref$onEditDescriptio === void 0 ? function () {} : _ref$onEditDescriptio;
  var _useState = (0, _react.useState)(description),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    editedDescription = _useState2[0],
    setEditedDescription = _useState2[1];
  var onChange = function onChange(event) {
    var value = event.target.value;
    setEditedDescription(value);
    onEditDescription(value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(textAreaStyles.textarea, styles.editDescription)
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    name: "asset-description",
    className: textAreaStyles.textarea,
    placeholder: "Description",
    onChange: onChange,
    disabled: isDisabled,
    value: editedDescription,
    maxLength: MAX_LENGTH,
    "data-test-id": "edit-asset-description-textarea"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.descriptionFooter
  }, /*#__PURE__*/_react.default.createElement("span", null, (_editedDescription$le = editedDescription === null || editedDescription === void 0 ? void 0 : editedDescription.length) !== null && _editedDescription$le !== void 0 ? _editedDescription$le : 0, "/", MAX_LENGTH, " characters")));
};
var _default = exports.default = Description;
//# sourceMappingURL=EditDescription.js.map